const links = [
  { label: 'LLM Availability', href: 'https://llm.hackstudio.dev' },
  { label: 'ML Availability', href: 'https://ml.hackstudio.dev' },
  { label: 'World Timezone', href: 'https://timezone.hackstudio.dev' },
  { label: 'Timers', href: 'https://timers.hackstudio.dev' },
  { label: 'Train Tracker', href: 'https://traintracker.hackstudio.dev' },
  { label: 'FPL', href: 'https://fpl.hackstudio.dev' },
  { label: 'Sudoku', href: 'https://sudoku.hackstudio.dev' },
  { label: 'AltTab', href: 'https://alttab.hackstudio.dev' },
  { label: 'GitHub', href: 'https://github.com/hasack' },
];

export default function App() {
  return (
    <div className="page">
      <header className="brand">
        <img src="/favicon.ico" alt="" className="brand-mark" />
        <span className="brand-name">hackstudio</span>
      </header>
      <nav>
        {links.map(({ label, href }) => (
          <a key={href} href={href} target="_blank" rel="noopener noreferrer">
            {label}
          </a>
        ))}
      </nav>
    </div>
  );
}
